import React from "react";
import "./css/About.css";
import { motion } from "framer-motion";

export default function About() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      style={{ minHeight: "100vh" }}
       className="about-bg"
    >
    <section>
      <div className="about-content">
        <img
          src="/images/your-avatar.png" // Update path if needed
          alt="Your Avatar"
          className="about-avatar"
        />
        <h2 className="about-title">About Me</h2>
        <p className="about-intro">
          Tech enthusiast and builder, I thrive on bringing complex ideas to life—from automating brokerage workflows with Selenium to designing scalable systems in Django, MongoDB, and React. My projects span stock market analysis, AI-powered apps, dynamic UIs, and creative productivity tools, blending backend automation with modern frontend innovation. As the creator of the @techbull.ai. YouTube page, I love sharing tech insights and building practical tools that empower others. Driven by curiosity and continuous learning, I’m always exploring new technologies and launching solutions that connect business, automation, and real-world impact.
          {/* <p>Hi, I’m Milind, with a strong passion for technology, automation, and building practical digital tools. My journey spans across multiple domains, from stock market analysis and data engineering to full-stack development and AI-powered applications. I enjoy turning complex ideas into working systems—whether it’s automating brokerage workflows with Selenium, designing scalable databases, or building dynamic UIs with React, React Native, and modern frontend frameworks like Vite.</p>

<p>I’m constantly exploring new technologies. I’ve worked with Django, MongoDB, Appwrite, TradingView screeners, and even ventured into affiliate marketing website development. My interest in machine learning and AI also shows through projects like stock prediction models and RAG-based chatbots. I enjoy experimenting with backend automation, starting and stopping services via scripts, and integrating real-world APIs into my projects.</p>

<p>Creativity extends beyond code—I run a tech-focused Instagram page named techbull, where I share knowledge and insights with a growing audience. I also love building tools that help others, such as trading journals, handwriting improvement apps, and productivity workflows.</p>

<p>Driven by curiosity and a desire to improve, I continue expanding my skills—from React Native navigation to database design to prompt engineering—always working on something new and challenging. Whether it’s a business idea, a coding project, or an automation problem, I love diving deep and bringing solutions to life.</p> */}
        </p>
        <div className="about-skills">
          <span className="skill-tag">Python</span>
          <span className="skill-tag">ReactJS</span>
          <span className="skill-tag">Django</span>
          <span className="skill-tag">LangChain</span>
          <span className="skill-tag">Generative AI</span>
          <span className="skill-tag">Freelancing</span>
        </div>
      </div>
    </section>
    </motion.section>
  );
}
